import { alpha, } from '@mui/material/styles';
import { Menu, IconButton, Box, Tooltip, } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const StyledMenu = (props) => {
    return (
        <Menu
            elevation={0}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            transformOrigin={{
                horizontal: 'left',
                vertical: 'top',
            }}
            sx={{
                '& .MuiPaper-root': {
                    bgcolor: 'background.paper',
                    border: 1,
                    borderColor: 'borderColor.main',
                    boxShadow: 2,
                    color: 'text.primary',
                    minWidth: 150,
                    mt: 1,
                    p: 0,
                    '&:hover': {
                        boxShadow: 5,
                    },
                    '& .MuiMenu-list': {
                        py: 0.5,
                    },
                    '& .MuiMenuItem-root': {
                        color: 'text.primary',
                        fontSize: 14,
                        '&:hover': {
                            bgcolor: 'transparent',
                            color: 'secondary.main',
                        },
                        '&:active': {
                            bgcolor: (theme) => alpha(
                                theme.palette.text.secondary,
                                theme.palette.action.selectedOpacity,
                            ),
                        },
                    },
                },
            }}
            {...props}
        />);
};

export default function OperationsCustomizedMenu({ title, anchorEl, handleClickOperations, handleCloseOperations, sx = [], children, ...props }) {

    const open = Boolean(anchorEl);

    return (
        <Box sx={[
            ...(Array.isArray(sx) ? sx : [sx])
        ]} {...props}>
            <Tooltip title='Больше' placement='left' arrow>
                <IconButton
                    id={`operations-{${title}-customized-button`}
                    aria-controls={`operations-{${title}-customized-menu`}
                    aria-haspopup='true'
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickOperations}
                    sx={{
                        border: 1,
                        borderColor: 'borderColor.main',
                        color: 'text.primary',
                        p: ['5px', '6px', '7px', '8px'],
                        '&:hover': {
                            borderColor: 'secondary.main',
                            color: 'secondary.main',
                        },
                    }}>
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            <StyledMenu
                id={`operations-{${title}-customized-menu`}
                MenuListProps={{
                    'aria-labelledby': `operations-{${title}-customized-button`,
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseOperations}
            >
                {children}
            </StyledMenu>
        </Box>
    );
};